import { listen, qs, qsa } from "@fluorescent/dom";

const selectors = {
  filterGroup: '.filter-form__group[data-filter-group-has-search="true"]',
  filterListItem: "[data-filter-list-item]",
  searchInput: "[data-filter-search-input]",
  searchClear: "[data-filter-search-clear]",
};

/**
 * FilterSearch
 * @param {Object} node the filter form
 * @returns {Function} unload
 */
const FilterSearch = node => {
  if (!node) return false;

  const searchGroups = {};
  _initSearchGroups();
  const events = [
    listen(node, "keyup", _handleKeyup),
    listen(node, "click", _handleClick),
  ];

  function _initSearchGroups() {
    qsa(selectors.filterGroup, node).forEach(group => {
      const { filterLabel } = group.dataset;
      const searchGroup = {};
      searchGroup.groupContainer = group;

      searchGroup.filterListItems = qsa(selectors.filterListItem, group).map(
        filterListItemEl => {
          const { itemLabel } = filterListItemEl.dataset;
          return { filterListItemEl, itemLabel };
        }
      );

      searchGroups[filterLabel] = searchGroup;
    });
  }

  function _handleClick(evt) {
    const searchClearEl = evt.target.closest(selectors.searchClear);
    const filterGroupEl = evt.target.closest(selectors.filterGroup);
    if (searchClearEl && filterGroupEl) {
      const searchInputEl = qs(selectors.searchInput, filterGroupEl);
      searchInputEl.value = "";
      _updateSearch(searchInputEl);
    }
  }

  function _handleKeyup(evt) {
    const searchInputEl = evt.target.closest(selectors.searchInput);
    _updateSearch(searchInputEl);
  }

  function _updateSearch(searchInputEl) {
    if (!searchInputEl) return;

    const { filterLabel } = searchInputEl.dataset;
    const currentSearchGroup = searchGroups[filterLabel];

    if (!currentSearchGroup) return;

    const myExp = new RegExp(searchInputEl.value, "gi");
    let searchMatchCount = 0;

    currentSearchGroup.groupContainer.dataset.filterSearchActive =
      searchInputEl.value !== "";

    currentSearchGroup.filterListItems.forEach(filterListItem => {
      const searchMatch = filterListItem.itemLabel.search(myExp) !== -1;

      filterListItem.filterListItemEl.dataset.filterItemSearchMatch =
        searchMatch;

      if (searchMatch) {
        searchMatchCount++;
      }
    });

    currentSearchGroup.groupContainer.dataset.filterSearchEmpty =
      searchInputEl.value !== "" && searchMatchCount <= 0;
  }

  function unload() {
    events.forEach(unsubscribe => unsubscribe());
  }

  return {
    unload,
  };
};

export default FilterSearch;
